module.exports = __webpack_public_path__ + "static/media/inmoLogo.f7f4cfc4.png";